import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from './GoogleSheetsService';
import { StudentContext } from './StudentContext';
import './Login.css';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState('');
  const [modalMessage, setModalMessage] = useState('');
  const navigate = useNavigate();
  const { loadAndFilterData } = useContext(StudentContext);

  useEffect(() => {
    console.log('Login component mounted - Checking saved credentials');
    const savedUsername = localStorage.getItem('rememberedUsername');
    const savedPassword = localStorage.getItem('rememberedPassword');
    if (savedUsername && savedPassword) {
      setUsername(savedUsername);
      setPassword(savedPassword);
      setRememberMe(true);
    }
  }, []);

  const handleCloseModal = () => {
    setShowModal(false);
    if (modalType === 'success') {
      navigate('/main');
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    console.log('handleLogin called - Attempting login with username:', username);
    
    setModalType('loading');
    setModalMessage('Đang đăng nhập...');
    setShowModal(true);

    const result = await login(username, password);
    if (result.success) {
      console.log('Login successful - Storing data and loading student data');
      localStorage.setItem('isLoggedIn', 'true');
      localStorage.setItem('catechistFullName', result.fullName);
      localStorage.setItem('username', username);
      localStorage.setItem('catechistHolyName', result.holyName || '');
      localStorage.setItem('catechistClassName', result.className || '');
      localStorage.setItem('userRole', result.role || 'catechist');
      localStorage.setItem('blockLeader', result.blockLeader || '');
      localStorage.setItem('boardLeader', result.boardLeader || '');
      if (rememberMe) {
        localStorage.setItem('rememberedUsername', username);
        localStorage.setItem('rememberedPassword', password);
      } else {
        localStorage.removeItem('rememberedUsername');
        localStorage.removeItem('rememberedPassword');
      }
      setErrorMessage('');
      await loadAndFilterData();
      
      setModalType('success');
      setModalMessage('Đăng nhập thành công');
    } else {
      console.log('Login failed - Error:', result.message);
      setErrorMessage(result.message);
      setShowModal(false);
    }
  };

  const handleParentClick = () => {
    console.log('Navigating to /parent');
    navigate('/parent');
  };

  return (
    <div className="login-container glv-button">
      <img src="/logo.png" alt="Logo" className="logo" />
      <h2>Đăng Nhập</h2>
      <img src="/background.jpg" alt="Background" className="background-image" />
      <form onSubmit={handleLogin}>
        <div>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Tên đăng nhập"
            required
          />
        </div>
        <div>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Mật khẩu"
            required
          />
        </div>
        <div>
          <label>
            <input
              type="checkbox"
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
            />
            Ghi nhớ đăng nhập
          </label>
        </div>
        <button type="submit" className="confirm-button">Đăng Nhập</button>
        {errorMessage && <p className="error">{errorMessage}</p>}
      </form>
      <div className="parent-section">
        <p>Anh/Chị là phụ huynh?</p>
        <button onClick={handleParentClick} className="parent-button">
          Tra cứu thông tin thiếu nhi
        </button>
      </div>

      {showModal && (
        <div className={`notification-popup ${modalType}`}>
          <div className="notification-content">
            {modalType === 'loading' && <div className="spinner"></div>}
            <p>{modalMessage}</p>
            {modalType === 'success' && (
              <button onClick={handleCloseModal} className="confirm-button">
                Xác nhận
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Login;